import styled from 'styled-components/macro';

interface IProps {
  position: 'left' | 'right';
  expanded: boolean;
}

export const StyledCollapseButtonLine = styled.div<IProps>`
  width: 2px;
  background-color: ${(props) => props.theme.accent};
  height: 100%;
  position: absolute;
  left: ${(props) => (props.position === 'left' ? '1.2rem' : 'auto')};
  right: ${(props) => (props.position === 'right' ? '1.2rem' : 'auto')};
  top: 0;

  button {
    position: absolute;
    left: 50%;
    top: 40px;
    transform: translate(-50%, -50%) ${(props) => {
      if (
        (props.position === 'right' && props.expanded) ||
        (props.position === 'left' && !props.expanded)
      ) {
        return 'rotate(180deg)';
      }
      return 'rotate(0deg)';
    }};
    z-index: 1;
    cursor: pointer;
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid rgba(235, 237, 239, 0.08);
    box-shadow: 0 0.5rem 2rem 0 rgb(35 54 75 / 12%);
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: ${(props) => props.theme.accent};
      &:before {
        border-top: 2px solid ${(props) => props.theme.white};
        border-right: 2px solid ${(props) => props.theme.white};
      }
    }
    &:before {
      content: '';
      width: 0.7rem;
      height: 0.7rem;
      border-top: 2px solid ${(props) => props.theme.fontColor.primary};
      margin-left: -0.3rem;
      border-right: 2px solid ${(props) => props.theme.fontColor.primary};
      border-bottom: 2px solid transparent;
      border-left: 2px solid transparent;
      transform: rotate(45deg);
      transition: 0.2s;
    }
  }
`;
